import { ParametricsComponent } from './../../criterias/parametrics/parametrics.component';
import { ReportingConfigComponent } from './../../criterias/reporting-config/reporting-config.component';
import { DateCollectedComponent } from './../../criterias/date-collected/date-collected.component';
import { DemographicsComponent } from './../../criterias/demographics/demographics.component';
import { HospitalizationsComponent } from './../../criterias/hospitalizations/hospitalizations.component';
import { SpecimenLocationsComponent } from './../../criterias/specimen-locations/specimen-locations.component';
import { SpecimenSourcesComponent } from './../../criterias/specimen-sources/specimen-sources.component';
import { OrganismCategoriesComponent } from './../../criterias/organism-categories/organism-categories.component';
import { RegionsComponent } from './../../criterias/regions/regions.component';
import { GeographicCategoriesComponent } from './../../criterias/geographic-categories/geographic-categories.component';
import { Component, OnInit, Input, ViewChild, ComponentFactoryResolver, Injector, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from '../../api.service';
import { Router } from '@angular/router';
import { OrganismsComponent } from '../../criterias/organisms/organisms.component';
import { DrugCategoriesComponent } from '../../criterias/drug-categories/drug-categories.component';
import { DrugsComponent } from '../../criterias/drugs/drugs.component';
import { AlertService } from '../../alert.service';
import { ProjectsComponent } from '../../criterias/projects/projects.component';
import { CustomComponent } from '../../criterias/custom/custom.component';
import { CriteriaListComponent } from '../../criterias/criteria-list/criteria-list.component';
import { BreakpointsComponent } from '../../breakpoints/breakpoints.component';
import { MyUtility } from '../../comparison';
import { MolecularBladeComponent } from '../../criterias/molecular-blade/molecular-blade.component';
import { CriteriaValidationService } from '../../criteria-validation.service';
import { UserListComponent } from '../../admin/user-list/user-list.component';
import { UserLoginsComponent } from '../../admin/user-logins/user-logins.component';
import { SchemaAssignmentsComponent } from '../../admin/schema-assignments/schema-assignments.component';
import { ScattergramChartComponent } from '../../scattergram/scattergram-chart/scattergram-chart.component';

import { map } from 'rxjs/operators';
import { timer } from 'rxjs/observable/timer';
import { ThemeService } from '../../theme.service';

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.css']
})
export class ReportingComponent implements OnInit {
  title = 'SDLN 2.5';
  reportUrl = null;
  year = 2018;
  menuItems = [];
  selectedMenuItem = null;
  updateCount = 0;
  criteriaJson: string = null;

  blade1config = { visible: false, headerText: 'Left Blade', minWidth: null, component: null };
  blade2config = { visible: false, headerText: 'Right Blade', minWidth: null, component: null };

  @ViewChild('dynamic', {
    read: ViewContainerRef
  }) viewContainerRef: ViewContainerRef;

  private timer;

  constructor(
    public api: ApiService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private changeDetRef: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private alerter: AlertService,
    private critValidation: CriteriaValidationService,
    public themeSvc: ThemeService
  ) {
    let interval = 10 * 60 * 1000; // 10 minutes
    this.timer = timer(interval, interval);
    this.timer.subscribe(x => {
      let req = api.keepAlive();
      req.setIsLoading = false;
      req.successFunc = r => {
        if (!r.isLoggedIn) {
          this.handleSessionEnd();
        }
      };
      req.start();
    });
  }

  sessionEnded = false;
  handleSessionEnd() {
    if (this.sessionEnded) {
      return;
    }

    this.sessionEnded = true;

    this.alerter.alert("Your session has ended. Please log in again");
    this.router.navigate(['/login']);
  }

  clearAllCriteria() {
    this.api.session.currentCriteria = MyUtility.deepCopy(this.api.originalCriteria);
    this.closeLeftBlade();
  }

  get isDevEnvironment() {
    return location.hostname === 'localhost';
  }

  migraine() {
    console.log('This is giving me a migraine');
  }
  doUpdate() {
    if (!this.updateCount) {
      this.updateCount = 0;
    }

    console.log('doUpdate: ' + (this.updateCount = this.updateCount + 1));
    if (this.updateCount < 5) {
      this.migraine();
    } else {
      this.updateCount = 0;
    }
  }

  getDoUpdate() {
    return () => this.migraine();
  }

  i = 0;
  menuLookup = {
    "Region": [
      {
        headerText: "Geographic Categories", component: GeographicCategoriesComponent, updater: function () {
          console.log("Geographic Categories blade update");
          this.blade2config.visible = this.api.session.currentCriteria.regions.selectedCategory != null;
          this.blade2config.headerText = this.api.session.currentCriteria.regions.selectedCategory.name;
          this.blade2config.component = null;
          this.changeDetRef.detectChanges();
          this.blade2config.component = RegionsComponent;
        }
      },
      { headerText: "Regions", component: RegionsComponent }
    ],
    "Organism": [
      {
        headerText: "Select Organism View", component: OrganismCategoriesComponent, updater: function () {
          this.blade2config.visible = this.api.session.currentCriteria.organisms.selectedCategory != null;
          this.blade2config.headerText = "Showing " + this.api.session.currentCriteria.organisms.selectedCategory.name;
          this.blade2config.component = null;
          this.changeDetRef.detectChanges();
          this.blade2config.component = OrganismsComponent;
        }
      },
      { headerText: "Organisms", component: OrganismCategoriesComponent }
    ],
    "Drug": [
      {
        headerText: "Drug Families", component: DrugCategoriesComponent, updater: function () {
          this.blade2config.visible = this.api.session.currentCriteria.drugs.selectedCategory != null;
          this.blade2config.headerText = this.api.session.currentCriteria.drugs.selectedCategory.name;
          this.blade2config.component = null;
          this.changeDetRef.detectChanges();
          this.blade2config.component = DrugsComponent;
        }
      },
      { headerText: "Drugs", component: DrugCategoriesComponent }
    ],
    "SpecimenSource": [
      {
        headerText: "Specimen Sources", component: SpecimenSourcesComponent, updater: function () {
        }
      }
    ],
    "Projects": [
      {
        headerText: "Projects", component: ProjectsComponent, updater: function () {
        }
      }
    ],
    "ParametricFilters": [
      {
        headerText: "Parametric Filters", component: ParametricsComponent, updater: function () {
        }
      }
    ],
    "SpecimenLocation": [
      {
        headerText: "Specimen Locations", component: SpecimenLocationsComponent, updater: function () {
        }
      }
    ],
    "Hospitalization": [
      {
        headerText: "Options", component: HospitalizationsComponent, updater: function () {
        }
      }
    ],
    "Demographics": [
      { headerText: "Patient Gender", component: DemographicsComponent, updater: function () { }, showBlade2: true },
      { headerText: "Date Collected", component: DateCollectedComponent, updater: function () { } }
    ],
    "Custom": [
      { headerText: "Custom", component: CustomComponent, updater: function () { } }
    ],
    "Molecular": [
      {
        headerText: "Molecular", component: MolecularBladeComponent, minWidth: '700px', updater: function () {
        }
      }
    ]
  };

  public hasParametric: boolean;
  public parametricTitle: string;

  ngOnInit() {
    this.menuItems = this.api.session.menuList.map(x => x);

    let parametrics = this.menuItems.filter(x => x.Key === 'ParametricFilters');
    console.log("para", parametrics);
    if (parametrics.length === 1) {
      console.log("has para");
      this.hasParametric = true;
      this.parametricTitle = parametrics[0].DisplayText;
      this.menuItems.splice(this.menuItems.indexOf(parametrics[0]), 1);
    }
    console.log("menuList: ", { hasPara: this.hasParametric, "title": this.parametricTitle });
  }

  logout() {
    // this.api.disableErrorHandlingForNextRequest = true;
    let request = this.api.logout();
    request.doneFunc = data => {
      console.log('done');
      this.router.navigate(['/login']);
    };
    request.start();
  }

  bladeMode = false;

  menuClick(menuItem) {
    this.bladeMode = true;
    this.selectedMenuItem = menuItem;
    this.blade1config.visible = false;
    this.blade2config.visible = false;
    this.reportUrl = null;

    if (!menuItem) {
      return;
    }

    let item = menuItem.IsCustom ? this.menuLookup.Custom : this.menuLookup[menuItem.Key];
    console.log("item: " + menuItem.Key + " -> " + item);
    if (item) {
      // console.log("item: ", item);
      // console.log("menuItem: ", menuItem);

      let headerText = menuItem.IsCustom ? menuItem.DisplayText : item[0].headerText;
      this.blade1config.headerText = headerText;
      this.blade1config.component = item[0].component;
      this.blade1config.minWidth = item[0].minWidth;
      this.blade1config.visible = true;
      this.migraine = item[0].updater;

      if (item[0].showBlade2) {
        this.blade2config.headerText = item[1].headerText;
        this.blade2config.component = item[1].component;
        this.blade2config.visible = true;
      }
    }
  }

  showCriteriaJson() {
    this.criteriaJson = JSON.stringify(this.api.session.currentCriteria);
  }

  get currentCriteria() {
    if (!this.api) {
      return null;
    }

    if (!this.api.session) {
      return null;
    }

    return this.api.session.currentCriteria;
  }

  runReport() {
    let validationResult = this.critValidation.validate(this.currentCriteria);
    if (!validationResult.isValid) {
      let msg = "Please fix the following problems before proceeding:\n"
        + validationResult.validationProblems.map(x => "• " + x).join('\n');

      this.alerter.alert(msg);

      return;
    }


    let request = this.api.prepareReport(this.session.selectedUserView);
    request.successFunc = data => {
      console.log('prepareReport data: ' + JSON.stringify(data));
      let url = data;
      console.log('url: ' + url);
      if (url) {
        this.menuClick(null);
        this.reportUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }
    };
    request.start();
  }

  showReporting() {
    this.showNonBlade(ReportingConfigComponent);
  }

  showCriteriaList() {
    this.showNonBlade(CriteriaListComponent);
  }

  showParametric() {
    this.showNonBlade(ParametricsComponent);
    // this.showNonBlade(ScattergramChartComponent);
  }

  get hasUserAdmin() {
    return this.api.session.hasUserAdmin;
  }

  get reportLink() {
    return this.api.getReportExcelLink(this.api.session.currentCriteria.reportConfig.selectedType.id);
  }

  showBreakpoints() {
    this.showNonBlade(BreakpointsComponent);
  }

  showUserAdmin() {
    this.showNonBlade(UserListComponent);
  }

  showUserLogins() {
    this.showNonBlade(UserLoginsComponent);
  }

  showScattergram() {
    this.showNonBlade(ScattergramChartComponent);
  }

  showSchemaAssignments() {
    this.showNonBlade(SchemaAssignmentsComponent);
  }

  showNonBlade(type) {
    this.menuClick(null);

    this.reportUrl = null;

    this.bladeMode = false;
    this.changeDetRef.detectChanges();

    let x = type;
    this.viewContainerRef.clear();
    if (!x) {
      return;
    }

    const factory = this.componentFactoryResolver.resolveComponentFactory(x);
    const component = factory.create(this.viewContainerRef.parentInjector);
    let comp: any;
    comp = component.instance;
    this.viewContainerRef.insert(component.hostView);
  }

  closeLeftBlade() {
    console.log("closeLeftBlade");
    this.menuClick(null);
  }

  closeRightBlade() {
    console.log("closeRightBlade");
    this.blade2config.visible = false;
  }

  get session() {
    return this.api.session;
  }

  get logoUrl() {
    return this.sanitizer.bypassSecurityTrustUrl(this.api.session.reportLogo);
  }

  public setView(view) {
    let req = this.api.selectView(view);
    req.successFunc = x => {
      this.clearAllCriteria();
      this.router.navigate(['/viewReload']);
    };
    req.start();
    // this.session.selectedUserView = view;
  }

  public get userViews() {
    return this.session.userViews;
  }

  public get selectedViewName() {
    return this.session.selectedUserView;
  }
  public set selectedView(value) {
    this.session.selectedUserView = value;
  }
}
